// Backend API configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://buylist.tcgsync.com/api';

console.log(`Backend URL: ${BACKEND_URL}`);
